export enum AppPermission {
  CAMPAIGN_READ = "campaign:read",
  CAMPAIGN_PARTICIPATE = "campaign:participate",
  CAMPAIGN_WRITE = "campaign:write",
  ORGANIZATION_MANAGE = "organization:manage",
  BILLING_READ = "billing:read",
  BILLING_WRITE = "billing:write",
  ROLE_READ = "role:read",
  ROLE_WRITE = "role:write",
  INVITE_READ = "invite:read",
  INVITE_WRITE_PARTICIPANT = "invite:write:participant",
  INVITE_WRITE = "invite:write",
}

export interface AppRole {
  id: string,
  created_at: string
  updated_at: string
  organization_id: string,
  name: string,
  description: string,
  role_backward_compatibility_id?: number
  permissions: AppPermission[],
}

export enum MemberRole {
  OWNER = 0,
  ADMINISTRATOR = 1,
  USER = 2,
  PARTCIPANT = 3,
  CONSULTANT = 4,
}

const memberPermissions = [
  AppPermission.CAMPAIGN_PARTICIPATE,
  AppPermission.CAMPAIGN_READ,
  AppPermission.CAMPAIGN_WRITE,
  AppPermission.INVITE_WRITE_PARTICIPANT,
  AppPermission.INVITE_WRITE,
  AppPermission.INVITE_READ,
  AppPermission.ORGANIZATION_MANAGE,
  AppPermission.ROLE_READ,
  AppPermission.ROLE_WRITE,
];

const ownerPermissions = [
  AppPermission.BILLING_READ,
  AppPermission.BILLING_WRITE,
  AppPermission.CAMPAIGN_PARTICIPATE,
  AppPermission.CAMPAIGN_READ,
  AppPermission.CAMPAIGN_WRITE,
  AppPermission.INVITE_WRITE_PARTICIPANT,
  AppPermission.INVITE_WRITE,
  AppPermission.INVITE_READ,
  AppPermission.ORGANIZATION_MANAGE,
  AppPermission.ROLE_READ,
  AppPermission.ROLE_WRITE,
];

const consultantPermissions = [
  AppPermission.INVITE_WRITE_PARTICIPANT,
  AppPermission.INVITE_READ,
  AppPermission.CAMPAIGN_READ,
];

const adminPermissions = [
  AppPermission.BILLING_READ,
  AppPermission.BILLING_WRITE,
  AppPermission.CAMPAIGN_PARTICIPATE,
  AppPermission.CAMPAIGN_READ,
  AppPermission.CAMPAIGN_WRITE,
  AppPermission.INVITE_WRITE_PARTICIPANT,
  AppPermission.INVITE_WRITE,
  AppPermission.INVITE_READ,
  AppPermission.ORGANIZATION_MANAGE,
  AppPermission.ROLE_READ,
  AppPermission.ROLE_WRITE,
];

export const PredefinedRoles = {
  [MemberRole.OWNER]: ownerPermissions,           // OWNER
  [MemberRole.ADMINISTRATOR]: adminPermissions,   // ADMIN
  [MemberRole.USER]: memberPermissions,           // USER
  [MemberRole.CONSULTANT]: consultantPermissions, // CONSULTANT
}